// FormComplete.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const FormComplete = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToForms = () => {
      setTimeout(() => {
        navigate('/employee_forms', { 
          replace: true,
          state: { 
            formCompleted: true,
            timestamp: Date.now()
          } 
        });
      }, 2000);
    };

    redirectToForms();
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 2,
        p: 3,
        textAlign: 'center'
      }}
    >
      <Typography variant="h5">
        Form completed successfully!
      </Typography>
      <Typography variant="body1">
        Returning to forms...
      </Typography>
      <CircularProgress />
    </Box>
  );
};

export default FormComplete;